import React, { useState, useMemo } from 'react'
import styles from './styles.module.css'

function PriceExpandedRecords ({ record }) {
  // State to manage the expanded view
  const [isExpanded, setIsExpanded] = useState(false)

  // Console log record only when it changes
  // useEffect(() => {
  //     console.log('Record:', record);
  // }, [record]);

  // Define the getStatus function - uses new type field with fallback to old logic
  const getStatus = price => {
    // Use the new type field if available
    if (price?.type) {
      switch (price.type) {
        case 'Sale List':
          return 'For Sale'
        case 'Sale':
          return 'Sold'
        case 'Rental List':
          return 'For Rent'
        default:
          return price.type // Return the type as-is if it's a new value we don't recognize
      }
    }

    // Fallback to old logic for backwards compatibility
    // if (price?.period === "Per Month") {
    //     return "For Rent";
    // } else if (price?.availability === true || price?.availability === "true") {
    //     return "For Sale";
    // } else if (price?.availability === false || price?.availability === "false") {
    //     return "Sold";
    // } else {
    //     return "N/A";
    // }
  }

  const sortedPrices = useMemo(
    () =>
      record && Array.isArray(record.prices)
        ? [
            // First, sort entries with dates by date in descending order
            ...record.prices
              .filter(price => price.date)
              .sort((a, b) => new Date(b.date) - new Date(a.date))
              // Filter to remove duplicate dates — prefer entry that has a type
              .filter((price, _index, self) => {
                const sameDate = self.filter(p => p.date === price.date)
                if (sameDate.length === 1) return true
                const withType = sameDate.find(p => p.type)
                return withType ? price === withType : price === sameDate[0]
              }),

            // Then, sort entries without dates by amountMax
            ...record.prices
              .filter(price => !price.date)
              .sort((a, b) => (b.amountMax || 0) - (a.amountMax || 0)) // Sort by amountMax (largest first)
              // Filter to remove duplicates based on amountMax
              .filter(
                (price, index, self) =>
                  index === self.findIndex(p => p.amountMax === price.amountMax)
              )
          ]
        : [],
    [record]
  )

  const formatDate = dateString => {
    if (!dateString) return 'Unknown date'
    const date = new Date(dateString)
    if (isNaN(date)) return 'Invalid Date'
    return new Intl.DateTimeFormat('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    }).format(date)
  }

  return (
    <section>
      <span className={styles.priceHistory}>Price history</span>
      <div className={styles.priceHistoryContainer}>
        {sortedPrices.length > 0 ? (
          sortedPrices
            .slice(0, isExpanded ? sortedPrices.length : 5)
            .map((price, index) => (
              <div key={index} className={styles.priceHistoryContainerFields}>
                <span className={styles.priceHistoryAmount}>
                  {new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                  }).format(price?.amountMax)}
                </span>
                <span className={styles.priceHistoryDate}>
                  {formatDate(price?.date)}
                </span>
                <span className={styles.priceHistorySale}>
                  {getStatus(price)}
                </span>
              </div>
            ))
        ) : (
          <span>N/A</span>
        )}
      </div>

      {sortedPrices.length > 5 && (
        <button
          className={styles.expandButton}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? 'Show less' : `Expand All (${sortedPrices.length})`}
        </button>
      )}
    </section>
  )
}

export default PriceExpandedRecords
